import React from "react";

const ClientSays = () => {
  const testimonials = [
    {
      image:
        "https://s3-alpha-sig.figma.com/img/ebc0/707f/04a123fd0af031d4c911cbf0bb3a4a45?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=cBHmXoUoT88bckFskmy5gM9yNBBQnp9j762xdVzhkhGsRlJEDHn~l4IVkgN49RwmlFb22rl5F0bFrDeoydGKpoxpSTCLWNeJDsEiGLKhxqupwVJBp2g5TGP~Y2MMmvQjripqIWXn59THeWnqlBKpKpY~Dul3Nl3XN-bQXa2GfYyIFs40WMvYiwewa80BfjAnUCb-UMWy4-GSDY1Ea6pVY8D9x-5xiOIwtL-mRm0D-Yy6igmjYsCI52MFjQTU896vrYUgQ8MTcVtNY98OEQrHomNIjI0ZIvIqB47EUH53hYdywTaDaPTHHFCSqZlaFWcX8nSrNBekVYRVsQO3oxJW3Q__",
      name: "Annie Clark",
      designation: "",
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, seddo eiusmod tempor incididunt.",
    },
    {
      image:
        "https://s3-alpha-sig.figma.com/img/2a6f/285a/50b9d4cb11d4aa5b6bfdd1cbf081e37f?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=CQVH9eX-ZhFkoyu7vfs6A4eXUp4dzBIokMNGNZUj2Y2pM-047jupuFq0ahYDtMj2~eEkHkTlO1qf5XJTXw4G7L8ZHt4E7HiFr8bGt07eCtl6s3V07C4yjGd3NzJEDjhQMyLBX-JT0fj9~GPh61WHPFfyWOCeTCF9oOEl7zV1Tr4PNO7FZGLbbfJ~JXfCh8MMSi3fYYlE4FaynfkGJG~gcufDe-emt55f1-8N51sP~E5O0RwEYfO1NTrOF6JzT8IOI2Hp4Hys2MVxG0Z5B-BEcTk9P4ZRtVYCOS7r~y56NC~Ig~e7QyjZtDzpjCoPsNpthdRwlTcBBJnUzDcqJPgQyg__",
      name: "Jeff MacLaren",
      designation: "",
      quote:
        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
    },
    {
      image:
        "https://s3-alpha-sig.figma.com/img/e9a1/3591/c3d108ad4985871e6da26a9c79aee760?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=iCCm5kFsRG505xtz-OvLIKH9kOT0ggsmSBqhYpgPEX62pUShaIfblqbSonaW2nCl85Vcz67B2SvHmA26aS65gV2xsKGDWZcjbRNUMT-1obE~gVPz03DMiIqabXvh2paV6taBImMIt3d2i4bqmjHp0xJs0SaLLHBW9TUo4dBuMfDws1HT2lqLx24-ObGxQL8H4Lo1X~Vbt7PKA8hpBq0owyt6clfxZBy2UpBlTXYkiJwVOsJPBG0h8AcIpGKb9AsKU4~sUULs4a7JNc~Ij2n4PT~MmMlheaEMyR3dFMQ4CTpYP6FIh6hkiBefUHcib-q-ljJwQEg9THUM8SLtMP53rg__",
      name: "Tony Derozen",
      designation: "",
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore.",
    },
    {
      image:
        "https://s3-alpha-sig.figma.com/img/5aab/5459/786b226d5d70e39a1dfa0e817fee1e4d?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=juED2AD2NTzlDPwkyzvY-mQP3AoLDaZx7SIZtdGwoZbl5ubGN-zR2KSVO2DBpKunIRd6HfxPPPQI6yTDmuMA-8h6uPtLBzahuNJ9TIClZCmHSHO3EiNcyxgBmYIyi5WWfD5XLkp30Z8CDsXMJ~dcf9XU257W6J2eGkvP06t~lMoPGlf2yWSxRVIKemT9G3HBXCTJDyFjRH8Bpw1gsI6sylek9IlCaUUCWep9t4RH7VaTUBhj3cP-8Uvc1HB3mVSFmcai5EUNCZV4up~XW9qIGjTGnlg4L1-vCgby4vnmF4M2dosHdWKZhPHgOh-opVdPOjXhJi5pRNyQUsiUoz4Zrg__",
      name: "Maria Thompson",
      designation: "",
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore.",
    },
    {
      image:
        "https://s3-alpha-sig.figma.com/img/acb6/e86e/c642d2a6f99d832b4002b4ec3202af53?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=ntQOhThRhAC1X~qwAPOUlUi4BrvPgWNkDhvTWdutaBn82U9qYJgvdGAn-o5j6mxz6HjOox5Dgu6f8HL7UXCq4C8aBpth1S6es0vcoUrK1YCpP04iE0b1lMJlfEXMUP-DLxJx351I~dN9F1C8HH4Ynhd33ty~2L4fUF~MzUioDKnKZecDD44B3E~-Itxlr36UvfR-x8bK78FOaz-QvAfg87O-1-Lzv69qFnCeiJo~PSWotRtvgl3uD3fEVfxNdkCogQ5kKAh2ukfWj91aqREGKybkUoVJK0A97hmbNYez~kNlHVnaD4QaSkTsv9emiIvlK9Qtr0yQLKmlJChhpyYQNw__",
      name: "Jess Walker",
      designation: "",
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque.",
    },
    {
      image:
        "https://s3-alpha-sig.figma.com/img/9724/1b30/881648282610142e041ea81f5c63ba7d?Expires=1745193600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=HlrScTV7-STym7N~p2ARAn7ANba7n3M1RRdn8NZOYq-kdOF1J0bBFzHOq2EYeZHB447bbd4HnseaqN2Vo3Yj2fpm~LtJ75WIyagkXEozS9hAnCui7P-WWKGYEO8PFvdgn9sZLfsmdNPrBwGyjC5ynSuJ3~XSx9ojcG2MW8Rskyf5BWrnaQE2o4Xs0nXo9vGNePei5pD2qDKV-c5fbwVa7PLbAIQ09oX8J4obuE0l95HHSMsNxaVnH2fCQE8cLtF8yIkJScUOhiEvUZGd22Hq~dLS0fZlp8bSdC6U8SukhCI-1LTWjsQaaUCDzj2bRtGNAVgENyPvn-210EOF7MaIqw__",
      name: "Matt Pippen",
      designation: "",
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
  ];

  return (
    <section className="w-full my-12 md:my-28">
      <div className="w-full">
        <div className="space-y-8 px-5">
          <div className="font-normal  text-black font-IBM text-[48px] text-center w-full">
            <span className="italic">What Do Our Clients Say?</span>
            <br />
          </div>
          <div className="text-center font-medium text-black font-Outfit text-[16px] max-w-[545px] mx-auto">
            Enhance your succession strategy with our powerful evaluation tools:
            Board Strength, 9Box Now, and Executive Audit 360. These integrated
            tools provide data-driven insights that support informed
            decision-making, reduc- ing subjectivity and enhancing the overall
            effectiveness of your succession planning process.
          </div>
        </div>
      </div>
      <div className="w-full px-4 md:px-16 py-10">
        <div className="columns-1 sm:columns-2 md:columns-3 gap-5 space-y-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="break-inside-avoid rounded-2xl shadow-xl bg-white pt-8 pb-16 pl-6 pr-10"
            >
              <div className="flex items-start gap-3">
                <div className="relative w-[72px] aspect-[1/1] rounded-full overflow-hidden flex-shrink-0 border-4 border-transparent hover:border-cyan-500">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-shrink">
                  <h4 className="text-[16px] font-Outfit font-semibold text-[#55BDB3]">
                    {t.name}
                  </h4>
                  <p className="mt-1 text-[16px] font-Outfit font-normal text-black leading-relaxed">
                    “{t.quote}”
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientSays;
